import React, { useEffect, useState, useContext } from 'react';
import Unity, { UnityContext } from 'react-unity-webgl';
import { Helmet } from 'react-helmet-async';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
import { useLoginRedirect } from 'hooks/useLoginRedirect';
import { routes } from '../../routing/routes';

const unityContext = new UnityContext({
  loaderUrl: '/gamebuild/DuskBreakers_WebGL.loader.js',
  dataUrl: '/gamebuild/DuskBreakers_WebGL.data.gz',
  frameworkUrl: '/gamebuild/DuskBreakers_WebGL.framework.js.gz',
  codeUrl: '/gamebuild/DuskBreakers_WebGL.wasm.gz',
  productName: 'DuskBreakers Beast Battle',
  productVersion: process.env.REACT_APP_GAME_BUILD_VERSION,
  companyName: 'Metatheory INC',
  webglContextAttributes: {
    alpha: true,
    antialias: false,
    depth: true,
    failIfMajorPerformanceCaveat: true,
    powerPreference: 'high-performance',
    premultipliedAlpha: true,
    preserveDrawingBuffer: true,
    stencil: true,
    desynchronized: true,
    xrCompatible: false,
  },
});

export default function Game() {
  const [isLoaded, setIsLoaded] = useState(false);
  const { navigator } = useContext(NavigationContext);

  useLoginRedirect({ follow: routes.game() });

  useEffect(() => {
    // @ts-ignore We are purposely using an unsupported method, since react
    // router 6 does not allow us to block navigation
    const unblock = navigator.block(async (tx) => {
      if (tx.location.pathname !== '/game') {
        if (isLoaded) {
          await unityContext.quitUnityInstance();
          await setIsLoaded(false);
          tx.retry();
        } else {
          unblock();
          tx.retry();
        }
      }
    });

    return unblock;
  }, [navigator, isLoaded]);

  useEffect(function () {
    unityContext.on('loaded', function () {
      setIsLoaded(true);
    });
    unityContext.on('quitted', function () {
      setIsLoaded(false);
    });
  }, []);

  useEffect(() => {
    if (isLoaded) {
      let pageBottom = document.querySelector('#autoscroll-target');
      pageBottom?.scrollIntoView();
    }
  }, [isLoaded]);

  function renderLoadingScreen() {
    return (
      <div className="py-6">
        <h1 className="text-center mb-5">Loading</h1>
        <p className="text-center text-large">
          Please wait. The game client is large
          <br />
          and may take some time to download.
        </p>
        <div className="loader">Loading</div>
      </div>
    );
  }

  function renderGame() {
    return (
      <div className="game-container">
        <Unity
          unityContext={unityContext}
          style={{
            height: '100%',
            width: '100%',
          }}
        />
      </div>
    );
  }

  return (
    <main className="play">
      <Helmet>
        <title>Beast Battler - DuskBreakers</title>
        <meta name="description" content="Beast Battler Game" />
      </Helmet>

      <section style={{
        paddingTop: 'var(--navbar-height)',
      }}>
        <div className="loader-wrapper">
          {!isLoaded && renderLoadingScreen()}
          {renderGame()}
        </div>
      </section>
    </main>
  );
}
